import React from "react";

function WelcomeModal({ onClose }) {
  return (
    <div className="aic-modal-overlay" onClick={onClose}>
      <div className="aic-welcome-modal" onClick={(e) => e.stopPropagation()}>
        <div className="aic-welcome-modal__icon">
          <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
            <rect width="56" height="56" rx="16" fill="#EEF3FF" />
            <path d="M28 14C20.268 14 14 20.268 14 28s6.268 14 14 14 14-6.268 14-14S35.732 14 28 14zm0 2c6.627 0 12 5.373 12 12S34.627 40 28 40 16 34.627 16 28s5.373-12 12-12z" fill="#3f73f9" opacity="0.2"/>
            <path d="M22 26l4 4 8-8" stroke="#3f73f9" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="36" cy="20" r="5" fill="#3f73f9"/>
            <path d="M34.5 20l1 1 2-2" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>

        <h2 className="aic-welcome-modal__title">Добро пожаловать в AI Креативы</h2>
        <p className="aic-welcome-modal__subtitle">
          Создавайте профессиональные рекламные баннеры за секунды с помощью искусственного интеллекта
        </p>

        <div className="aic-welcome-modal__features">
          <div className="aic-welcome-modal__feature">
            <div className="aic-welcome-modal__feature-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="#3f73f9"/>
              </svg>
            </div>
            <div>
              <strong>3 варианта дизайна</strong>
              <span>Минималистичный, яркий и премиум-стиль</span>
            </div>
          </div>
          <div className="aic-welcome-modal__feature">
            <div className="aic-welcome-modal__feature-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <rect x="3" y="3" width="8" height="8" rx="1" fill="#3f73f9"/>
                <rect x="13" y="3" width="8" height="5" rx="1" fill="#3f73f9" opacity="0.6"/>
                <rect x="3" y="13" width="8" height="5" rx="1" fill="#3f73f9" opacity="0.6"/>
                <rect x="13" y="10" width="8" height="11" rx="1" fill="#3f73f9" opacity="0.4"/>
              </svg>
            </div>
            <div>
              <strong>Все форматы</strong>
              <span>728×90, 300×250, 300×600 — готовые ресайзы</span>
            </div>
          </div>
          <div className="aic-welcome-modal__feature">
            <div className="aic-welcome-modal__feature-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z" fill="#3f73f9"/>
              </svg>
            </div>
            <div>
              <strong>Быстрая генерация</strong>
              <span>Заполните форму и получите баннеры за 30 секунд</span>
            </div>
          </div>
        </div>

        <button className="aic-btn aic-btn--primary aic-btn--full" onClick={onClose}>
          Начать создавать
        </button>
      </div>
    </div>
  );
}

export default WelcomeModal;
